export function getApiBaseUrl(): string {
  const protocol = window.location.protocol;
  const host = window.location.hostname;
  const port = host === "localhost" ? ":8091" : "";
  return `${protocol}//${host}${port}/api`;
}
